<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Payment Settings'"
      [canGoBack]="!cantGoBack" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>


      <tidy-card>
        <tidy-row class="extra-bottom-padding">
          <tidy-radio-button
            [label]="'How do you want to pay?'"
            formControlName="setting"
            [form]="form.controls.setting"
            [items]="[{viewValue: 'Charge in advance (save 10%)', value: 'before_cleaning'},{viewValue: 'Charge after job', value: 'after_cleaning'}]"
            class="no-margin-first" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'This setting only applies to new pros that you find via TIDY, not pros you add.'" />
        </tidy-row>
      </tidy-card>

      <tidy-error-message
        [text]="errorMessage" />

      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSave"
        class="primary" />

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
